const t = {
  MOBILE: "mobile",
  DESKTOP: "desktop",
  TABLET: "tablet"
};
export {
  t as PLATFORM
};
